// @ts-nocheck
/* eslint-disable */
import { CONFIG, store } from "~/route/globals";
import { enrichHistoryWithDescription, getHistory, removeHistoryItem } from "~/util/providers/history";
import { node, icon } from "~/util/dom";
import { description } from "~/util/providers/poiagg";

export default class FixedSuggest {
	constructor(container, suggestMapClick) {
		this._suggestMapClick = suggestMapClick;
		this._dom = {
			container,
			fixedSuggest: node("div", { className: "fixed-suggest" }),
			historyList: node("div", { className: "history-list" }),
			history: icon("history"),
			home: icon("home"),
			work: icon("work")
		};
		container.appendChild(this._dom.fixedSuggest);
		const { user } = store.getState().user;
		this._isLogged = user.state === "green";
		this._data = {
			history: [],
			home: null,
			work: null
		};
		this._historyOpen = false;

		// nastavime
		this._suggestMapClick.setEvents(() => {
			this._onFocus();
		}, withTimeout => {
			this._onBlur(withTimeout);
		});
	}

	destroy() {
	}

	handleEvent(e) {
		if (e.type == "pointerdown") {
			if (this._dom.history.contains(e.target)) {
				e.stopPropagation();
				e.preventDefault();

				if (this._historyOpen) {
					this._closeHistory();
				}
				else {
					Mapy.getComponent("logger").log("click", {
						text: "poipicker_history_all"
					});

					this._openHistory();
				}
			}
			else if (this._dom.home.contains(e.target)) {
				e.stopPropagation();
				e.preventDefault();

				// analytika - nove logovani sjednocene s appkou
				Mapy.Util.analyticsSearchSelection({
					query: "",
					search_type: "fixed_suggestion",
					result_type: "home",
					index: 1,
					search_purpose: "route_planner",
					target: ""
				}, this._data.home);
				Mapy.getComponent("logger").log("click", {
					text: "poipicker_home"
				});
				// bug #M-7990: my reagujeme na pointerdown, ktery neumi prevent na click
				setTimeout(() => {
					this._suggestMapClick.setData(this._data.home);
				}, 100);
			}
			else if (this._dom.work.contains(e.target)) {
				e.stopPropagation();
				e.preventDefault();

				// analytika - nove logovani sjednocene s appkou
				Mapy.Util.analyticsSearchSelection({
					query: "",
					search_type: "fixed_suggestion",
					result_type: "work",
					index: 2,
					search_purpose: "route_planner",
					target: ""
				}, this._data.work);
				Mapy.getComponent("logger").log("click", {
					text: "poipicker_work"
				});
				// bug #M-7990: my reagujeme na pointerdown, ktery neumi prevent na click
				setTimeout(() => {
					this._suggestMapClick.setData(this._data.work);
				}, 100);
			}
			else if (this._dom.fixedSuggest.contains(e.target)) {
				e.stopPropagation();
				e.preventDefault();
			}
		}
		else if (e.type == "input") {
			let value = this._suggestMapClick.input.value.trim();

			this._dom.fixedSuggest.classList[value.length ? "add" : "remove"]("not-empty");
		}
	}

	_onFocus() {
		const { user } = store.getState().user;
		this._dom.container.addEventListener("pointerdown", this);
		this._suggestMapClick.input.addEventListener("input", this);


		getHistory(user, {
			limit: 20,
			lang: CONFIG.langPriority,
		}).then(async data => {
			this._data.history = await enrichHistoryWithDescription(data?.data?.items || []);
			this._build();
		}, e => {});

		Mapy.ProviderMapyBox.getHomeAndWork().then(data => {
			this._data.home = JSON.parse(JSON.stringify(data.home));
			this._data.work = JSON.parse(JSON.stringify(data.work));
			if (data.home) {
				this._data.home.id = data.home.source_id;
			}

			if (data.work) {
				this._data.work.id = data.work.source_id;
			}

			this._build();
		}, e => {});
	}

	_onBlur() {
		this._dom.container.removeEventListener("pointerdown", this);
		this._suggestMapClick.input.removeEventListener("input", this);
		this._dom.fixedSuggest.classList.remove("not-empty");

		this._dom.history.remove();
		this._dom.home.remove();
		this._dom.work.remove();
		this._closeHistory();
	}

	_build() {
		const { user } = store.getState().user;

		if (this._data.history.length && user.state === "green") {
			this._dom.fixedSuggest.appendChild(this._dom.history);
		} else {
			this._dom.history.remove();
		}

		if (this._data.home) {
			this._dom.fixedSuggest.appendChild(this._dom.home);
		} else {
			this._dom.home.remove();
		}

		if (this._data.work) {
			this._dom.fixedSuggest.appendChild(this._dom.work);
		} else {
			this._dom.work.remove();
		}
	}

	_openHistory() {
		if (this._historyOpen) return;

		this._dom.fixedSuggest.classList.add("history-open");
		this._historyOpen = true;
		this._dom.container.appendChild(this._dom.historyList);

		this._buildHistoryList();
	}

	_buildHistoryList() {
		this._dom.historyList.classList[this._data.history.length > 7 ? "add" : "remove"]("over7-items");
		this._dom.historyList.innerHTML = "";

		this._data.history.filter(i => i.type == "poi").forEach((i, index) => {
			const item = node("a", { className: "history-item", href: "#" });
			const texts = node("div", { className: "texts" });
			const title = node("span", { className: "title", textContent: i.title });
			const subtitle = node("span", { className: "subtitle", textContent: i.secondRow || "" });
			const rightPart = node("span", { className: "right-part" });
			const removeSvg = icon("delete");

			item.appendChild(icon("history"));
			texts.appendChild(title);
			texts.appendChild(subtitle);
			item.appendChild(texts);
			rightPart.appendChild(removeSvg);
			item.appendChild(rightPart);
			item.addEventListener("pointerdown", e => {
				if (removeSvg.contains(e.target)) {
					e.preventDefault();
					e.stopPropagation();

					const { user } = store.getState().user;

					removeHistoryItem(user, {
						type: i.type,
						title: i.title,
						data: i.data,
					}).then(() => {
						setTimeout(() => {
							const { user } = store.getState().user;
							getHistory(user, {
								limit: 20,
								lang: CONFIG.langPriority,
							}).then(async data => {
								this._data.history = await enrichHistoryWithDescription(data?.data?.items || []);
								this._buildHistoryList();
							}, () => {});
						}, 200);
					}, () => {});
				} else {
					// open
					description([{ source: i.data.entitySource, id: i.data.entityId, }]).then(reqData => {
						let descriptionData = reqData.poi && reqData.poi.length ? reqData.poi[0] : null;

						if (descriptionData) {
							// analytika - nove logovani sjednocene s appkou
							let title = i.title.trim();

							Mapy.Util.analyticsSearchSelection({
								query: title,
								search_type: "fixed_suggestion",
								result_type: "history_poi",
								index: index + 1,
								search_purpose: "route_planner",
								name: title,
								poi_id: i.data.entityId,
								poi_source: i.data.entitySource,
								poi_title: title,
								target: ""
							});
							this._suggestMapClick.setData(descriptionData);
						}
					}, () => {});
				}
			});
			this._dom.historyList.appendChild(item);
		});
	}
	_closeHistory() {

		if (!this._historyOpen) return;

		this._dom.fixedSuggest.classList.remove("history-open");
		this._historyOpen = false;
		this._dom.historyList.remove();
	}
}
